import { render, staticRenderFns } from "./LaudoItemModelo.vue?vue&type=template&id=481fb2d6&scoped=true&"
import script from "./LaudoItemModelo.vue?vue&type=script&lang=js&"
export * from "./LaudoItemModelo.vue?vue&type=script&lang=js&"
import style0 from "./LaudoItemModelo.vue?vue&type=style&index=0&id=481fb2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481fb2d6",
  null
  
)

export default component.exports